import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';

type Props = {
  label: string;
  value: React.ReactNode;
  subtitle?: string;
  tone?: 'default' | 'success' | 'warning' | 'error' | 'info';
};

class FWizardSummaryCard extends React.PureComponent<Props> {
  color() {
    if (this.props.tone === 'success') return 'success.main';
    if (this.props.tone === 'warning') return 'warning.main';
    if (this.props.tone === 'error') return 'error.main';
    if (this.props.tone === 'info') return 'info.main';
    return 'text.primary';
  }

  render() {
    return (
      <Card elevation={1}>
        <CardContent>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">{this.props.label}</Typography>
            <Typography variant="h6" sx={{ fontWeight: 800, color: this.color() }}>
              {this.props.value}
            </Typography>
            {this.props.subtitle && (
              <Typography variant="caption" color="text.secondary">{this.props.subtitle}</Typography>
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

export default FWizardSummaryCard;
